export class EventSponsor {
  public constructor() {
    this.SponserId = 0;
    this.ProfileId = 0;
    this.EventId = 0;
    this.DateCreated = new Date();
    this.DateChanged = new Date();
    this.SponsorMessage = '';
    this.SponsorLogoUrl = '';
    this.SponsorWebsite = '';
    this.SponsorName = '';
    this.Sort = '';
    this.DoNotDisplay = false;
    this.HideSponsorOrgName = false;
  }
  public SponserId: number;
  public ProfileId: number;
  public EventId: number;
  public DateCreated: Date;
  public DateChanged: Date;
  public SponsorMessage: string;
  public SponsorLogoUrl: string;
  public SponsorWebsite: string;
  public SponsorName: string;
  public Sort: string;
  public DoNotDisplay: boolean;
  public HideSponsorOrgName: boolean;
}
